import ErnstigeBloedingenOnderTar from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-tar.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderTar,
  ChartCollapse,
  React
};